module.exports = __webpack_public_path__ + "static/mevia-extraimg1@2x-min-cfd38d8b1d6d1c741239f954a0cfe85b.png";